import React from 'react';
import { Link, useLocation, useNavigate  } from 'react-router-dom';

const Sidebar = ({ open, setOpen, isMobile }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const logout = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            localStorage.removeItem('admin_token');
            localStorage.removeItem('admin_name');
            navigate('/'); // redirect to root
        }
    };
    return (
        <>
            {/* Overlay for mobile */}
            {isMobile && open && (
                <div
                    style={overlay}
                    onClick={() => setOpen(false)}
                />
            )}

            <div
                style={{
                    ...sidebar,
                    transform:
                        isMobile
                            ? open
                                ? 'translateX(0)'
                                : 'translateX(-100%)'
                            : 'translateX(0)'
                }}
            >
                <h5 style={{ marginBottom: '20px' }}>Admin Panel</h5>

                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li>
                        <Link
                            to="/admin/dashboard"
                            style={navLink(location.pathname === '/admin/dashboard')}
                            onClick={() => isMobile && setOpen(false)}
                        >
                            Dashboard
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/admin/forms"
                            style={navLink(location.pathname.startsWith('/admin/forms'))}
                            onClick={() => isMobile && setOpen(false)}
                        >
                            Forms
                        </Link>
                    </li>

                    <li>
                        <Link
                            to="/"
                            style={navLink(false)}
                        >
                            Home
                        </Link>
                    </li>
                    <li style={{ marginTop: '30px' }}>
                        <button onClick={logout} style={logoutBtn}>
                            Logout
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default Sidebar;

/* ---------- styles ---------- */

const sidebar = {
    width: '220px',
    background: '#c31a1a',
    color: '#fff',
    padding: '20px',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 1000,
    transition: 'transform 0.3s ease'
};

const overlay = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    zIndex: 999
};

const navLink = (active) => ({
    display: 'block',
    color: '#fff',
    textDecoration: 'none',
    padding: '10px',
    borderRadius: '4px',
    background: active ? 'rgba(255,255,255,0.2)' : 'transparent'
});
const logoutBtn = {
    width: '100%',
    background: '#990707ff',
    color: '#fff',
    border: 'none',
    padding: '10px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: '600'
};